import { useSelectedCollectionAssets } from '@features/Collection/hooks';
import { SharedClipTable } from '@features/Clip/components/SharedClipTable';
import { useTranslation } from 'react-i18next';

export const AvailableContentSection = () => {
    const { t } = useTranslation(['clipTable']);

    return (
        <SharedClipTable
            queryHook={useSelectedCollectionAssets}
            initialPageSize={10}
            minRows={10}
            configOverrides={{
                title: t('title'),
            }}
        />
    );
};
